import { TAIL_SPEND } from 'utils/detailsChartDataConverter';

export const getDiagonalPattern = stroke => {
	return {
		pattern: {
			path: {
				d: 'M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2',
				strokeWidth: 1,
				stroke,
			},
			width: 4,
			height: 4,
		},
	};
};

export const getCategoryLevelFromBreadcrumbs = breadcrumbs => {
	breadcrumbs = breadcrumbs || [];

	let level = breadcrumbs.length;

	if (level && breadcrumbs.indexOf(TAIL_SPEND) !== -1) {
		level -= 1;
	}

	return level;
};
